import { render, staticRenderFns } from "./ColorFormField.vue?vue&type=template&id=995efae4&"
import script from "./ColorFormField.vue?vue&type=script&lang=js&"
export * from "./ColorFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports